import React from "react";

const rules = [
  <>
    18 yaşdan aşağı olan azyaşlıların valideynlərdən icazəsiz saytdan
    alış-veriş etməsi qadağandır.
  </>,
  <>
    Azyaşlıların valideyndən icazəsiz etdiyi alış-verişə ffqadir.az saytı
    məsuliyyət daşımır.
  </>,
  <>
    Sifariş verilərkən səhv verilən məlumatlara əsasən baş verən problemlər
    müştərinin məsuliyyəti üzərindədir (səhv yazılan İD, oyun hesabı və s.).
  </>,
  <>
    <strong className="text-white">ffqadir.az</strong> saytında verilən bank
    hesablarından başqa hesablara edilən ödənişlərə{" "}
    <strong className="text-white">ffqadir.az</strong> saytı məsuliyyət daşımır.
  </>,
  <>
    <strong className="text-white">ffqadir.az</strong> saytında paylaşılan bank
    hesablarına edilən ödənişlərin qəbzini başqalarıyla paylaşmaq qadağandır.
    Əks-halda bütün məsuliyyət paylaşan vətəndaşın üzərindədir.
  </>,
  <>
    <strong className="text-white">ffqadir.az</strong> saytında verilən əlaqə
    nömrələrindən başqa şəxslərlə baş verən problemlərə{" "}
    <strong className="text-white">ffqadir.az</strong> məsuliyyət daşımır.
  </>,
];

const Note = () => {
  return (
    <main className="relative min-h-screen w-full overflow-x-hidden bg-[#07050e] text-white selection:bg-[#d6b36a]/30 selection:text-[#d6b36a]">
      {/* Arka plan glow efektleri */}
      <div className="pointer-events-none absolute left-1/2 top-0 h-[500px] w-full max-w-7xl -translate-x-1/2 overflow-hidden opacity-40">
        <div className="absolute top-[-100px] left-1/2 h-[350px] w-[600px] -translate-x-1/2 rounded-full bg-gradient-to-tr from-purple-800 to-indigo-600 blur-[130px]" />
        <div className="absolute top-[100px] left-1/3 h-[250px] w-[300px] rounded-full bg-[#d6b36a]/20 blur-[100px]" />
      </div>

      {/* Başlık Bölümü */}
      <section className="relative z-10 pt-20 pb-10 text-center px-4">
        <div className="inline-flex items-center gap-2 rounded-full border border-[#d6b36a]/20 bg-[#d6b36a]/10 px-4 py-1.5 backdrop-blur-md">
          <span className="h-2 w-2 rounded-full bg-[#d6b36a] animate-pulse" />
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#d6b36a]">
            FF QADİR
          </p>
        </div>

        <h1 className="mt-6 text-3xl font-black tracking-tight text-transparent bg-clip-text bg-gradient-to-b from-white via-gray-100 to-gray-400 sm:text-5xl">
          Qanunlar və Qaydalar
        </h1>

        <p className="mt-3 text-sm text-gray-400 max-w-md mx-auto">
          Saytımızdan istifadə etməzdən əvvəl aşağıdakı qaydalarla tanış olmağınız xahiş olunur.
        </p>

        <div className="mx-auto mt-6 h-[2px] w-24 bg-gradient-to-r from-transparent via-[#d6b36a] to-transparent" />
      </section>

      {/* Qaydalar Bölümü */}
      <section className="relative z-10 mx-auto w-full max-w-4xl px-4 pb-20 sm:px-6">
        <div className="relative overflow-hidden rounded-3xl border border-white/10 bg-[#110c1d]/80 p-6 shadow-2xl backdrop-blur-xl sm:p-10">
          
          {/* İç kart glow detayları */}
          <div className="pointer-events-none absolute -right-32 -top-32 h-80 w-80 rounded-full bg-purple-600/15 blur-[100px]" />
          <div className="pointer-events-none absolute -bottom-32 -left-32 h-80 w-80 rounded-full bg-[#d6b36a]/10 blur-[100px]" />

          <div className="relative z-10">
            <div className="mb-8 flex items-center gap-4">
              <div className="h-px flex-1 bg-gradient-to-r from-transparent via-[#d6b36a]/30 to-transparent" />
              <span className="text-xs font-extrabold uppercase tracking-[0.25em] text-[#d6b36a]/90">
                Şərtlər & Məsuliyyət
              </span>
              <div className="h-px flex-1 bg-gradient-to-r from-transparent via-[#d6b36a]/30 to-transparent" />
            </div>

            <ul className="space-y-4">
              {rules.map((rule, index) => (
                <li
                  key={index}
                  className="group relative flex items-start gap-4 rounded-2xl border border-white/5 bg-white/[0.02] p-4 sm:p-5 transition-all duration-300 hover:border-[#d6b36a]/30 hover:bg-white/[0.05] hover:shadow-lg hover:shadow-purple-950/20"
                >
                  {/* Numaralandırma */}
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl border border-[#7b5ce1]/30 bg-[#7b5ce1]/10 text-sm font-black text-[#a78bfa] transition-colors duration-300 group-hover:border-[#d6b36a]/50 group-hover:bg-[#d6b36a]/10 group-hover:text-[#d6b36a]">
                    {String(index + 1).padStart(2, "0")}
                  </span>

                  {/* Metin */}
                  <p className="pt-1 text-sm leading-relaxed text-gray-300 sm:text-base group-hover:text-gray-100 transition-colors duration-300">
                    {rule}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Note;